import { EnvironmentService, Environment } from '@galaxy/core';
import { Injectable } from '@angular/core';

@Injectable()
export class StripeUrlService {
  private _host: string;

  constructor(private environmentService: EnvironmentService) {}

  private getHost(): void {
    if (this._host) {
      return;
    }
    switch (this.environmentService.getEnvironment()) {
      case Environment.PROD: {
        this._host = '//dashboard.stripe.com';
        break;
      }

      case Environment.DEMO: {
        this._host = '//dashboard.stripe.com/test';
        break;
      }

      default: {
        this._host = '//dashboard.stripe.com/test';
        break;
      }
    }
  }

  public getChargeDetailsUrl(chargeId: string): string {
    this.getHost();
    return `${this._host}/payments/${chargeId}`;
  }
}
